import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AppService } from './app.service';
import { CoreService } from './core/core.service';
import { AuthModule } from './auth/auth.module';
import { ToastrModule } from 'ngx-toastr';

import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';

import { HighchartsChartModule } from 'highcharts-angular';
import { ExcelService } from './core/xlsx.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    ToastrModule.forRoot(),
    HighchartsChartModule,
  ],
  providers: [AppService, CoreService, DecimalPipe, ExcelService],
  bootstrap: [AppComponent]
})
export class AppModule { }
